import React, { Fragment, useEffect, useState } from 'react';
import {
	Box,
	Typography,
	FormControl,
	TextField,
	InputAdornment,
	List,
	ListItem,
	Avatar,
	FormControlLabel,
	Checkbox,
	Tooltip,
	Chip,
	Tabs,
	Tab,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { CrossIcon, SearchIcon, SortingIcon } from '../../../../../config/svg/CommonSvgIcon';
import { BorderCheckboxIcon, CheckedIcon, UnCheckedIcon } from '../../../../../config/svg/formElementIcons';
import NouserImg from '../../../../../images/search-no-colleagues.svg';
import { NoRecord } from '../../../CommonComponent/NoRecord';
import { SkillRoleList } from './SkillRoleList';

export const DefaultSkillRoleList: React.FC<any> = (props: any) => {
	const { titleHead, rolesData, checkedUser, setCheckedUser, disabledUsers } = props;
	const { t } = useTranslation();
	return (
		<>
			<React.Fragment>
				<Tabs className='okr-tabs drawer-tabs' value={0} aria-label='Role Tabs'>
					<Tab label={t('Map Roles')} value={0} />
				</Tabs>
				<Box className='drawer-tabs-panel skill-role-list-panel'>
					<SkillRoleList
						rolesData={rolesData}
						checkedUser={checkedUser}
						setCheckedUser={setCheckedUser}
						disabledUsers={disabledUsers}
					/>
				</Box>
			</React.Fragment>
		</>
	);
};
